import { combineReducers } from '@reduxjs/toolkit';
import { Api } from '../api/root-api';
import { userSlice } from '../auth/slice';
import { eventsSlice } from '../events';
import { invoiceSlice } from '../invoice';
import { ledgerSlice } from '../ledger';
import { paymentSlice } from '../payment';
import { toastSlice } from '../toast';
import { userPreferenceSlice } from '../user-preference';
import { workspaceSlice } from '../workspace';
import { inviteSlice } from '../invite';
import { onboardingSlice } from '../onboarding';
import { sentTeamInvitesSlice } from '../sent-team-invites';
import { miscellaneousSlice } from '../miscellaneous';
import { kycSlice } from '../kyc';
import { ordersSlice } from '../orders';
import { schemesSlice } from '../schemes';
import { productsSlice } from '../products';
import { dayBookSlice } from '../daybook';
import { customersSlice } from '../customers';
import { filtersSlice } from '../filter/slice';
import { tableConfigSlice } from '../table-config';
import { returnsSlice } from '../returns';
import { superAdminSlice } from '../super-admin';
import { commsSlice } from '../channel';
import { msgSlice } from '../message';
import { drawerConfigSlice } from '../drawer-config';
import { zoeySlice } from '../zoey';
import { homeSlice } from '../home/slice';
import { sellerActionSlice } from '../seller-action';
import { divisionSlice } from '../division/slice';
import { priceListSlice } from '../price-list/slice';
import { threadSlice } from '../thread';
import { salesSlice } from '../sales';
import { campaignSlice } from '../campaigns/slice';
import { buyerToSellerSlice } from '../buyer-to-seller';
import { configSlice } from '../config';
import { tripSlice } from '../trip';
import { wahaSlice } from '../waha';
import { tourSlice } from '../tour/slice';
import { userViewPreferenceSlice } from '../user-view-preference';
import { agentSlice } from '../agent';
import { beatPlanSlice } from '../beat-plans/slice';
import { jtbdTourSlice } from '../jtbd-3.0';
import { signupJTBDSlice } from '../signup-jtbd';
import { simulatorSlice } from '../simulator/slice';
import { conversationSlice } from '../conversations';
import { dateStateSlice } from '../date';
import { commonDataSlice } from '../common';
import { customerContactSlice } from '../customer-contact';
import { growDashboardSlice } from '../grow-dashboard/slice';
import { reportFilterApiSlice } from '../reports';
import { persistedApiInspectorReducer } from '../api-inspector/slice';
import { moduleAccessSlice } from '../module-access/slice';

const appReducer = combineReducers({
  apiInspector: persistedApiInspectorReducer,
  [Api.reducerPath]: Api.reducer,
  [userSlice.name]: userSlice.reducer,
  [workspaceSlice.name]: workspaceSlice.reducer,
  [filtersSlice.name]: filtersSlice.reducer,
  [tableConfigSlice.name]: tableConfigSlice.reducer,
  [userViewPreferenceSlice.name]: userViewPreferenceSlice.reducer,
  [tourSlice.name]: tourSlice.reducer,
  [customerContactSlice.name]: customerContactSlice.reducer,
  [toastSlice.name]: toastSlice.reducer,
  [paymentSlice.name]: paymentSlice.reducer,
  [invoiceSlice.name]: invoiceSlice.reducer,
  [ledgerSlice.name]: ledgerSlice.reducer,
  [eventsSlice.name]: eventsSlice.reducer,
  [userPreferenceSlice.name]: userPreferenceSlice.reducer,
  [customersSlice.name]: customersSlice.reducer,
  [inviteSlice.name]: inviteSlice.reducer,
  [onboardingSlice.name]: onboardingSlice.reducer,
  [sentTeamInvitesSlice.name]: sentTeamInvitesSlice.reducer,
  [miscellaneousSlice.name]: miscellaneousSlice.reducer,
  [kycSlice.name]: kycSlice.reducer,
  [ordersSlice.name]: ordersSlice.reducer,
  [schemesSlice.name]: schemesSlice.reducer,
  [productsSlice.name]: productsSlice.reducer,
  [dayBookSlice.name]: dayBookSlice.reducer,
  [returnsSlice.name]: returnsSlice.reducer,
  [superAdminSlice.name]: superAdminSlice.reducer,
  [commsSlice.name]: commsSlice.reducer,
  [msgSlice.name]: msgSlice.reducer,
  [drawerConfigSlice.name]: drawerConfigSlice.reducer,
  [zoeySlice.name]: zoeySlice.reducer,
  [homeSlice.name]: homeSlice.reducer,
  [sellerActionSlice.name]: sellerActionSlice.reducer,
  [divisionSlice.name]: divisionSlice.reducer,
  [priceListSlice.name]: priceListSlice.reducer,
  [threadSlice.name]: threadSlice.reducer,
  [salesSlice.name]: salesSlice.reducer,
  [campaignSlice.name]: campaignSlice.reducer,
  [buyerToSellerSlice.name]: buyerToSellerSlice.reducer,
  [configSlice.name]: configSlice.reducer,
  [tripSlice.name]: tripSlice.reducer,
  [wahaSlice.name]: wahaSlice.reducer,
  [agentSlice.name]: agentSlice.reducer,
  [beatPlanSlice.name]: beatPlanSlice.reducer,
  [jtbdTourSlice.name]: jtbdTourSlice.reducer,
  [signupJTBDSlice.name]: signupJTBDSlice.reducer,
  [simulatorSlice.name]: simulatorSlice.reducer,
  [conversationSlice.name]: conversationSlice.reducer,
  [dateStateSlice.name]: dateStateSlice.reducer,
  [commonDataSlice.name]: commonDataSlice.reducer,
  [growDashboardSlice.name]: growDashboardSlice.reducer,
  [reportFilterApiSlice.name]: reportFilterApiSlice.reducer,
  [moduleAccessSlice.name]: moduleAccessSlice.reducer,
});

export default appReducer;
